import { useEffect, useRef } from 'react';
import type { Icon, IconWeight } from '@phosphor-icons/react';
import { m, useAnimation, useReducedMotion } from 'motion/react';

export interface TapIconProps {
  icon: Icon;
  size?: number;
  weight?: IconWeight;
  /** Change it (e.g. increment on tap) to play the pop once. */
  playKey: number;
}

const POP = { scale: [1, 0.85, 1.1, 1], transition: { duration: 0.32, ease: 'easeOut' as const } };

/** A Phosphor icon that answers a tap with a short pop — for icons Iconimate has no motion for. */
export function TapIcon({ icon: IconGlyph, size = 24, weight, playKey }: TapIconProps) {
  const controls = useAnimation();
  const reduced = useReducedMotion();
  const first = useRef(true);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    if (!reduced) void controls.start(POP);
  }, [playKey, reduced, controls]);

  return (
    <m.span className="inline-flex" animate={controls}>
      <IconGlyph size={size} weight={weight} />
    </m.span>
  );
}
